import {Carrier} from '../../../domain/carrier';

import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Shipment} from '../../../domain/shipment';
import {Router} from '@angular/router';
import {MatSort, Sort} from '@angular/material/sort';
import {Session} from '../../../domain/session';
import {SelectionModel} from '@angular/cdk/collections';
import {MatTableDataSource} from '@angular/material/table';

@Component({
    selector: 'app-shipment-list',
    templateUrl: './shipment-list.component.html',
    styleUrls: ['./shipment-list.component.css'],
    standalone: false
})
export class ShipmentListComponent implements AfterViewInit {
  @Input() headersVisible: boolean;
  @Input() showDeviationColumn: boolean;
  @Input() showStatusColumn: boolean;
  @Input() showUserColumn: boolean;
  @Input() disableUnchecked: boolean;
  @Input() showParcelCount: boolean;
  @Input() showUpdatedAt: boolean = true;
  @Input() showCreatedAt: boolean = false;

  _showAssignColumn: boolean;

  @Input('showAssignColumn')
  set showAssignColumn(value: boolean) {
    this._showAssignColumn = value;
    this.buildColumnList();
  }

  get showAssignColumn() {
    return this._showAssignColumn;
  }

  _multipleSelect: boolean;

  @Input('multipleSelect')
  set multipleSelect(value: boolean) {
    this._multipleSelect = value;
    this.buildColumnList();
  }

  get multipleSelect() {
    return this._multipleSelect;
  }

  @Output() sortChanged: EventEmitter<any> = new EventEmitter();
  @Output() assignShipment: EventEmitter<Shipment> = new EventEmitter<Shipment>();
  @Output() unassignShipment: EventEmitter<Shipment> = new EventEmitter<Shipment>();
  @Output() selectionToggled: EventEmitter<Shipment> = new EventEmitter<Shipment>();

  @ViewChild(MatSort) sort: MatSort;

  carriers: Carrier[];

  @Input('shipments')
  set shipments(value: Shipment[]) {
    this._shipments = value;

    this.buildColumnList();

    if (this.dataSource === undefined) {
      this.dataSource = new MatTableDataSource(this._shipments);
    } else {
      this.dataSource.data = this._shipments;
    }
  }

  private _shipments: Shipment[];

  selectedShipments = new SelectionModel<Shipment>(true, null);

  displayedColumns = [];

  dataSource: MatTableDataSource<Shipment>;

  constructor(private router: Router, session: Session) {
    this.carriers = session.getCarriers();
  }

  private buildColumnList() {
    const columns = [];

    columns.push('Number');

    if (this.showCreatedAt) {
      columns.push('CreatedAt');
    }

    columns.push('SenderName', 'ReceiverName', 'ReceiverAddress', 'ReceiverPostCode', 'ReceiverPlace');

    if (this.showStatusColumn) {
      columns.push('Status');
    }

    if (this.showDeviationColumn) {
      columns.push('DeviationName');
    }

    if (this.carriers !== undefined && this.carriers.length > 0) {
      columns.push('Carrier');
    }

    if (this.showUserColumn) {
      columns.push('User');
    }

    if (this.showParcelCount) {
      columns.push('ParcelCount');
    }

    if (this.showAssignColumn) {
      columns.push('Assign');
    }

    if (this.showUpdatedAt) {
      columns.push('UpdatedAt');
    }

    this.displayedColumns = columns;
  }

  selectShipment(row: Shipment) {
    if (this.multipleSelect) {
      this.selectedShipments.toggle(row);
      this.selectionToggled.emit(row);
    } else {
      this.router.navigate(['/admin/shipment', row.Number]);
    }
  }

  getCarrierName(carrierId: string) {
    const carrier = this.carriers.find(r => r.Id === carrierId);

    return carrier === undefined ? '' : carrier.Name;
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe((s: Sort) => {
      this.sortChanged.emit(s);
    });
  }

  assign(shipment: Shipment, $event) {
    $event.stopPropagation();

    this.assignShipment.emit(shipment);
  }

  unassign(shipment: Shipment, $event) {
    $event.stopPropagation();

    this.unassignShipment.emit(shipment);
  }

  public clearSelection() {
    this.selectedShipments.clear();
  }
}
